var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenInsureSankey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 600,
    width: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Your Diagram Title") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 600,
    width: 600,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sankey_flows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "flow0",
    d: "M9 197.89C288 197.89 288 176.83 567 176.83",
    fill: "none",
    strokeWidth: 177.66,
    stroke: "#595959",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("title", null, "Premiums \u2192 Claims: $630")), /*#__PURE__*/React.createElement("path", {
    id: "flow1",
    d: "M9 338.89C288 338.89 288 368.83 567 368.83",
    fill: "none",
    strokeWidth: 104.34,
    stroke: "#52c41a",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("title", null, "Premiums \u2192 Returned to Policy Holders: $370"))), /*#__PURE__*/React.createElement("g", {
    id: "sankey_nodes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "node"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "r0",
    className: "for_r0",
    x: 0,
    y: 109.06,
    height: 282,
    width: 9,
    fill: "#17becf",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("title", null, "Premiums:\n1,000"))), /*#__PURE__*/React.createElement("g", {
    className: "node"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "r1",
    className: "for_r1",
    x: 567,
    y: 21,
    height: 177.66,
    width: 9,
    fill: "#595959",
    fillOpacity: 1,
    transform: "translate(0,67)"
  }, /*#__PURE__*/React.createElement("title", null, "Claims:\n630"))), /*#__PURE__*/React.createElement("g", {
    className: "node"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "r2",
    className: "for_r2",
    x: 567,
    y: 436.66,
    height: 104.34,
    width: 9,
    fill: "#52c41a",
    fillOpacity: 1,
    transform: "translate(0,-120)"
  }, /*#__PURE__*/React.createElement("title", null, "Returned to Policy Holders:\n370")))), /*#__PURE__*/React.createElement("g", {
    id: "sankey_labels",
    fontFamily: "sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "label0_bg",
    className: "for_r0",
    x: 10.6327,
    y: 238.025,
    width: 140.66704,
    height: 23.29998,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.55,
    stroke: "none",
    strokeWidth: 0,
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "label0",
    className: "for_r0",
    textAnchor: "start",
    x: 15.29754,
    y: 250.06,
    dy: 5.364999999999999
  }, "Premiums: $1,000"), /*#__PURE__*/React.createElement("rect", {
    id: "label1_bg",
    className: "for_r1",
    x: 461.1612,
    y: 97.795,
    width: 104.20609,
    height: 23.3,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.55,
    stroke: "none",
    strokeWidth: 0,
    strokeOpacity: 0,
    transform: "translate(0,67)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "label1",
    className: "for_r1",
    textAnchor: "end",
    x: 560.70246,
    y: 109.83,
    dy: 5.364999999999999,
    transform: "translate(0,67)"
  }, "Claims: $630"), /*#__PURE__*/React.createElement("rect", {
    id: "label2_bg",
    className: "for_r2",
    x: 395.73933,
    y: 476.79498,
    width: 168.62797,
    height: 23.3,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.55,
    stroke: "none",
    strokeWidth: 0,
    strokeOpacity: 0,
    transform: "translate(0,-120)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "label2",
    className: "for_r2",
    textAnchor: "end",
    x: 560.70246,
    y: 488.83,
    dy: 5.364999999999999,
    transform: "translate(0,-120)"
  }, "Returned to You: $370")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInsureSankey);
export default __webpack_public_path__ + "static/media/open_insure_sankey.5846773cd1cd0d4c4c5b3181b19ebbe2.svg";
export { ForwardRef as ReactComponent };